<template>
  <div class="search">
    <div class="container">
      <a-input-search
        v-model:value="keyword"
        @search="onSearch"
        placeholder="請輸入關鍵字"
        style="padding: 10px; border-radius: 15px"
        title="搜尋框"
      />
    </div>
  </div>
</template>
<!--1.search事件，onSearch function name -->
<!--2.emits 事件name -upateShowNews -->
<!--3.setup 裡面會接受兩個參數 props響應式的，當傳入新的props時，它會被更新 / context js物件，不是響應式的，隨組件的更新而更新-->
<!--4.input search(事件) onSearch(方法) -->
<!--5.emit "upateShowNews"(事件) searchValue(參數) -->

<script>
import { defineComponent, ref } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "Search",
  emits: ["upateShowNews"],
  setup(props, { emit }) {
    const store = useStore();
    let keyword = ref("");
    keyword.value = store.getters["getSearchKeyword"];
    const onSearch = () => {
      emit("upateShowNews", keyword.value);
      // keyword.value = ''
    };
    return {
      keyword,
      onSearch,
    };
  },
});
</script>

<style lang="scss" scoped>
.search {
  padding-bottom: 40px;
  @include md {
    padding-bottom: 20px;
  }
  .ant-input-affix-wrapper {
    width: 35%;
    border: 1px solid #ccc;
    @include xl {
      width: 60%;
    }
    @include lg {
      width: 70%;
    }
    @include xs {
      width: 90%;
    }
  }
}
</style>
